import React from "react";
import { NavLink } from "react-router-dom";
import "./GalleryMenu.sass";

export const GalleryMenu = () => {
  return (
    <div className="GalleryMenu row">
      <nav>
        <ul>
          <li>
            <NavLink to="/galeria/2023/punta-cana/registros">Registros</NavLink>
          </li>
          <li>
            <NavLink to="/galeria/2023/punta-cana/prologo">Prólogo</NavLink>
          </li>
          <li>
            <NavLink to="/galeria/2023/punta-cana/etapa-1">Etapa 1</NavLink>
          </li>
          <li>
            <NavLink to="/galeria/2023/punta-cana/etapa-2">Etapa 2</NavLink>
          </li>
          <li>
            <NavLink to="/galeria/2023/punta-cana/etapa-3">Etapa 3</NavLink>
          </li>
          <li>
            <NavLink to="/galeria/2023/punta-cana/etapa-4">Etapa 4</NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};
